"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_CATEGORY_TREE = exports.GET_CATEGORY_BY_PARENTID = exports.GET_CATEGORY_BY_LEVEL = exports.GET_CATEGORY_BANNER = exports.GET_BRANDS_BY_CATEGORY = exports.GET_ALL_CATEGORY = exports.GET_ALL_BRANDS = void 0;
const GET_CATEGORY_BY_LEVEL = exports.GET_CATEGORY_BY_LEVEL = 'getCategoryByLevel';
const GET_CATEGORY_BY_PARENTID = exports.GET_CATEGORY_BY_PARENTID = 'getCategoryByParentId';
const GET_CATEGORY_BANNER = exports.GET_CATEGORY_BANNER = 'getCategoryBanner';
const GET_ALL_BRANDS = exports.GET_ALL_BRANDS = 'getAllBrands';
const GET_ALL_CATEGORY = exports.GET_ALL_CATEGORY = 'getAllCategory';
const GET_BRANDS_BY_CATEGORY = exports.GET_BRANDS_BY_CATEGORY = 'getBrandsByCategory';
const GET_CATEGORY_TREE = exports.GET_CATEGORY_TREE = 'getCategoryTree';